(function () {
  if (!window.B2B?.enabled) return;

  const BONUS_CLASS = 'b2b-item-bonus';
  let updatingNote = false;
  let lastNote = null;

  function applyBonus(container) {
    container.querySelectorAll('.cart-item').forEach(item => {
      item.querySelectorAll(`.${BONUS_CLASS}`).forEach(el => el.remove());

      const gramEl =
        item.querySelector('.cart-item__meta') ||
        item.querySelector('cart-item-default-property property-value');

      const qtyInput =
        item.querySelector('input[name^="updates"]') ||
        item.querySelector('input[name="updates[]"]');

      const microCopy = item.querySelector('.cart-item__micro-copy');

      if (!gramEl || !qtyInput || !microCopy) return;

      const grams = parseInt(gramEl.textContent, 10);
      const qty = parseInt(qtyInput.value, 10);

      const bonusKg = window.B2BUtils.calculateBonusKg({ grams, quantity: qty });
      if (!bonusKg) return;

      const bonus = document.createElement('div');
      bonus.className = BONUS_CLASS;
      bonus.style.cssText = `
        margin-top:6px;
        font-size:13px;
        color:#0CA18B;
      `;
      bonus.innerHTML = `🎁 <strong>Bonus B2B:</strong> +${bonusKg}kg`;

      microCopy.appendChild(bonus);
    });
  }

  async function updateCartNote() {
  if (updatingNote) {
    console.log("⛔ updateCartNote skipped (already updating)");
    return;
  }

  console.log("🔄 Fetching cart...");

  const res = await fetch('/cart.js');
  const cart = await res.json();

  console.log("🛒 CART:", cart);

  const { bonusKg, breakdown } =
    window.B2BUtils.calculateCartBonus(cart);

  console.log("📦 BREAKDOWN:", breakdown);
  console.log("🎁 TOTAL BONUS KG:", bonusKg);

  let noteText = '';

  if (bonusKg > 0) {

    const lines = breakdown.map(item => {
      console.log(`➡ ${item.title} → +${item.bonusKg}kg`);
      return `+${item.bonusKg}kg → ${item.title}`;
    });

    noteText =
`Bonus B2B:
${lines.join('\n')}
Total bonus: +${bonusKg}kg`;
  }

  console.log("📝 NOTE TEXT GENERATED:\n", noteText);

  if (noteText === lastNote) {
    console.log("⏭ Skipping update (note unchanged)");
    return;
  }

  updatingNote = true;
  console.log("⬆ Updating cart note...");

  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ note: noteText })
  });

  console.log("✅ Cart note updated successfully");

  lastNote = noteText;
  updatingNote = false;
}

  async function run() {
    applyBonus(document);
    await updateCartNote();
  }

  setTimeout(run, 300);

  document.addEventListener('input', run);
  document.addEventListener('click', run);
  document.addEventListener('cart:updated', run);

})();
